import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Congestion from '@/pages/Congestion'

Vue.use(Router)
Vue.use(VueAxios, axios)

const routes = [
  {
    path: '/congestion/:studioId',
    name: 'congestion',
    component: Congestion,
    beforeEnter: (to, from, next) => {
      next()
    },
  },
]


export default new Router({
  mode: 'history',
  routes: routes,
})
